<template>
    <button
        :class="{
            'is-selected is-primary has-background-dark': editor.isActive(type),
        }"
        class="button"
        @click="$emit('click')"
    >
        <span class="icon is-small">
            <i :class="`fa-${iconClass}`" class="fas" />
        </span>
    </button>
</template>

<script>
export default {
    props: {
        editor: {
            type: Object,
            required: true,
            default: () => {
                return {};
            },
        },
        type: {
            type: String,
            default: undefined,
            required: true,
        },
    },
    computed: {
        iconClass() {
            if (this.type == 'bulletList') {
                return 'list-ul';
            }
            return this.type;
        },
    },
};
</script>

<style></style>
